import Vue from 'vue';
import Vuex from 'vuex';
import axios from '../common/axios';
import Section from '../models/section'
import Leak from '../models/leak'
import * as R from 'ramda';
import router from '../router/routes';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // This is where you define the data structure of your application. You can also set default or initial state here.
    AccessLevel: {
      Admin: 4,
    },
    user: null,
    recovery: null,
    modalInfo: {},
    cclick: false,
    chartCurrentData: {},
    activeAlarms: [],
    recogAlarms: [],
    bitacora: {},
    dpDate: {
      showInfo: {
        hour: true
      },
      startTime: {
        time: ''
      },
      endtime: {
        // time: '2017-10-12'
      }
    },
    dpOpsFecha: {
      type: 'min',
      week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      month: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      format: 'YYYY-MM-DD HH:mm',
      placeholder: 'Fecha',
      inputStyle: {
        display: 'inline-block',
        padding: '0 10px',
        'line-height': '10px',
        'font-size': '16px',
        'border-bottom': '2px solid gray',
        color: '#5F5F5F',
        'background-color': 'transparent'
      },
      color: {
        header: '#166FB8',
        headerText: '#fff'
      },
      buttons: {
        ok: 'Ok',
        cancel: 'Cancelar',
        clear: 'Clear'
      },
      overlayOpacity: 0.5, // 0.5 as default
      dismissible: true // as true as default
    },
    dpOpsDesde: {
      type: 'min',
      week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      month: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      format: 'YYYY-MM-DD HH:mm',
      placeholder: 'Desde',
      inputStyle: {
        display: 'inline-block',
        padding: '0 10px',
        'line-height': '10px',
        'font-size': '16px',
        'border-bottom': '2px solid gray',
        color: '#5F5F5F',
        'background-color': 'transparent'
      },
      color: {
        header: 'var(--date-picker-background-color)',
        headerText: '#fff'
      },
      buttons: {
        ok: 'Ok',
        cancel: 'Cancelar'
      },
      overlayOpacity: 0.5, // 0.5 as default
      dismissible: true // as true as default
    },
    dpOpsHasta: {
      type: 'min',
      week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      month: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      format: 'YYYY-MM-DD HH:mm',
      placeholder: 'Hasta',
      inputStyle: {
        display: 'inline-block',
        padding: '0 10px',
        'line-height': '10px',
        'font-size': '16px',
        'border-bottom': '2px solid gray',
        color: '#5F5F5F',
        'background-color': 'transparent'
      },
      color: {
        header: 'var(--date-picker-background-color)',
        headerText: '#fff'
      },
      buttons: {
        ok: 'Ok',
        cancel: 'Cancelar'
      },
      overlayOpacity: 0.5, // 0.5 as default
      dismissible: true // as true as default
    },
    cached_ductos: null,
    transformed_cached_ductos: null,
    transformed_cached_leaks: [],
    last_leak_timestamp: null,
    cached_presion: null,

    fill: true,
    map: undefined,
    historico: null,
    options: [],
    optionsLegacy: [],
    estados: {
      verde: '',
      rojo: '',
      azul: '',
      amarillo: ''
    },
    routes: {

    },
    ETags: {},
    charts: {},
    monitoring: null,
    axiosSource: null,
    conceptos: null,
    help: null,
  },
  actions: {
    // Actions are where you define the calls that will commit changes to your store. A common example of this would be a call to an api to retrieve data, once it completes you call store.commit() to invoke a mutation to actually update the data in the store. Actions are called in your components via dispatch call.
	LOAD_OPS_LEGACY({ commit }, _params) {
		return new Promise((resolve, reject) => {
		axios.get(process.env.API_BASE_URL + 'legacy/pipelines')
			.then(resp => {
				if (!resp || resp.status !== 200) {
					throw new Error('Bad response')
				}
				let response = resp.data
				if (!response || response.code !== 200) {
					throw new Error('Bad data')
				}
				console.log('LOAD_OPS_LEGACY API response', response)
				this.state.optionsLegacy = []
				response.data.forEach((pipeline) => this.state.optionsLegacy.push(pipeline));
				console.log('optionsLegacy', this.state.optionsLegacy)
				return resolve(this.state.optionsLegacy)
			})
			.catch(err => {
				console.log('error', err)
				return reject(err)
			})
		})
	},
	GET_OP_LEGACY: state => param => {
		let arr = []
		state.optionsLegacy.forEach((op, _i) => {
			if (!op) return;
			if (op['id'] === param.id) {
				arr.push({
					name: site['ducto'],
					value: site['id']
				})
			}
		});
		console.log('GET_OP_LEGACY', arr)
		return arr
	},
	LOAD_HISTORICAL_LEGACY({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`${process.env.API_BASE_URL}legacy/alerts?pipeline=${params.pipeline}&startDate=${params.startDate}&endDate=${params.endDate}`)
				.then(resp => {
					if (!resp || resp.status !== 200) {
						throw new Error('Bad response');
					}
					let response = resp.data;
					if (!response || response.code !== 200) {
						throw new Error('Bad data');
					}
					console.log('LOAD_HISTORICAL_LEGACY', response);
					return resolve(response);
				})
				.catch(err => {
					console.log('error', err);
					return reject(err);
				});
		});
	},
    LOAD_HISTORICO({
      commit, getters
    }, params) {
      this.axiosSource = axios.CancelToken.source();
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.API_BASE_URL}leak?current=0&section=${params.ducto}&dateFrom=${params.desde}&dateTo=${params.hasta}&kmFrom=${params.kmFrom}&kmTo=${params.kmTo}&type=${params.tipo}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_HISTORICO_ID({
      commit, getters
    }, params) {
      this.axiosSource = axios.CancelToken.source();
      return new Promise((resolve, reject) => {
        const url = `${process.env.API_BASE_URL}leak/${params.id}`;
        axios
          .get(url)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              throw new Error('Bad data')
            }
            
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_HELP_INFO({
      commit, getters
    }, params) {
      var user = Vue.ls.get('user');
      if (user && user.permissions && user.permissions.length === 0) {
        return new Promise((resolve, reject) => {
          return resolve({ code: 200, data: [] });
        });
      }
      return new Promise((resolve, reject) => {
        const url = process.env.API_BASE_URL + 'question_answer';
        const headers = {};
        // headers['If-None-Match'] = getters.GET_ETAG(url)

        axios
          .get(`${process.env.API_BASE_URL}question_answer`, { headers })
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // reuse data
              if(response.code === 304) {
                return resolve(getters.GET_HELP);
              }

              throw new Error('Bad data')
            }
            const etag = resp.headers['etag'];
            commit('SET_ETAG', { url, etag });
            commit('SET_HELP', response);
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          });
      });
    },
    LOAD_PRESSURE_BY_ID({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        this.axiosSource.cancel;
        axios
          .get(`${process.env.API_BASE_URL}pressure?reportId=${params.reportId}&chartRange=${params.chartRange}`, { cancelToken: this.axiosSource.token })
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_REPORTE_POLL({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.API_BASE_URL}section/${params.ducto}/poll?dateFrom=${params.desde}&dateTo=${params.hasta}&site=${params.estacion}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_REPORTE_POOL_DETAILS({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.API_BASE_URL}section/${params.ducto}/poll_details?dateFrom=${params.desde}&site=${params.estacion}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_REPORTE_PRESSURE({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.API_BASE_URL}section/${params.ducto}/pressure?dateFrom=${params.desde}&dateTo=${params.hasta}&site=${params.estacion}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_REPORTE_PRESSURE_DETAILS({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.API_BASE_URL}section/${params.ducto}/pressure_details?dateFrom=${params.desde}&site=${params.estacion}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    POST_BITACORA({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${process.env.API_BASE_URL}journal`,
            {
              id_leak: '-1',
              username: params.username,
              id_section: params.id_section,
              id_concept: params.id_concept,
              comment: params.comment,
            })
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_BITACORA({
      commit, getters
    }, params) {
      return new Promise((resolve, reject) => {
        const url = process.env.API_BASE_URL + 'journal';
        const headers = {};
        // headers['If-None-Match'] = getters.GET_ETAG(url)

        axios
          .get(`${url}?id_section=${params.ducto}&id_concept=${params.concepto}&dateFrom=${params.desde}&dateTo=${params.hasta}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // reuse data
              if(response.code === 304) {
                return resolve();
              }

              throw new Error('Bad data')
            }
            const etag = resp.headers['etag'];
            commit('SET_ETAG', { url, etag });
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_CONCEPTOS({
      commit, getters
    }, params) {
      return new Promise((resolve, reject) => {
        const url = process.env.API_BASE_URL + 'journal/concept';
        const headers = {};
        // headers['If-None-Match'] = getters.GET_ETAG(url);

        axios
          .get(url, { headers })
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // reuse data
              if(response.code === 304) {
                return resolve(getters.GET_CONCEPTOS);
              }

              throw new Error('Bad data')
            }
            const etag = resp.headers['etag'];
            commit('SET_ETAG', { url, etag });
            commit('SET_CONCEPTOS', response);
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_DUCTOS({
      commit
    }) {
      var user = Vue.ls.get('user');
      if (user && user.permissions && user.permissions.length === 0) {
        return new Promise((resolve, reject) => {
          return resolve({ code: 200, data: [] });
        });
      }
      return new Promise((resolve, reject) => {
        axios
          .get(process.env.API_BASE_URL + 'site')
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            if (
              JSON.stringify(response.data) !==
              JSON.stringify(this.state.cached_ductos)
            ) {
              commit('SET_DUCTOS', {
                data: response.data
              })
              commit('SET_FILL_STATE', {
                data: true
              })
            } else {
              commit('SET_FILL_STATE', {
                data: false
              })
            }
            return resolve(response)
          })
          .catch(err => {
            commit('SET_DUCTOS', {
              data: this.state.cached_ductos
            })
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_DECIMATION({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.API_BASE_URL}site/decimation/${params.section}/${params.site}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_DECIMATION_STEP({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.API_BASE_URL}site/decimation_step/${params.section}/${params.site}/${params.report_data_id}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_DECIMATION_SITES({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.API_BASE_URL}site/decimation_sites/${params.minutes}/${params.sites_json}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_DECIMATION_DATE_RANGE({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${process.env.API_BASE_URL}site/decimation_date_range/${params.dateFrom}/${params.dateTo}/${params.sites_json}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_FUGAS({
      commit, getters
    }, params) {
      return new Promise((resolve, reject) => {
        let urlParams = ''
        params = params || {}
        params.last = this.state.last_leak_timestamp
        let count = 0
        for (let i in params) {
          if (R.isNil(params[i])) {
            continue
          }
          urlParams = urlParams + ((!count) ? '?' : '&') + i + '=' + params[i]
          count = count + 1
        }
        const url = process.env.API_BASE_URL + 'leak' + urlParams;
        const headers = {};
        // headers['If-None-Match'] = getters.GET_ETAG(url)
        axios
          .get(url, { headers })
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // reuse data
              if(response.code === 304) {
                return resolve();
              }

              throw new Error('Bad data')
            }
            const etag = resp.headers['etag'];
            commit('SET_ETAG', { url, etag });
            const sections = getters.allowedSections;

            commit('SET_FUGAS', {
              data: response.data
            })

            return resolve()
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    IDENTIFY_FUGA({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        params = params || {}
        if (!params.id) {
          return reject('Missing leak id')
        }
        axios
          .put(process.env.API_BASE_URL + 'leak/' + params.id, params)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response.data)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_GENERAL({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios.get(process.env.API_BASE_URL + `section/info?date=${params.fecha}`)
          .then(resp => {
            if (!resp || resp.status !== 200) { // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) { // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_SITE_INFO({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios.get(`${process.env.API_BASE_URL}site/info/${params.section}/${params.site}`)
          .then(resp => {
            if (!resp || resp.status !== 200) { // err servidor
              throw new Error('Bad response')
            }

            let response = resp.data
            if (!response || response.code !== 200) { // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_OPS({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios.get(process.env.API_BASE_URL + 'section/info')
          .then(resp => {
            if (!resp || resp.status !== 200) { // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) { // err data
              throw new Error('Bad data')
            }
            this.state.options = []
            response.data.forEach((r) => {
              this.state.options.push(JSON.parse(r.section_info))
            })
            return resolve(this.state.options)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_ESTADOS({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        const url = process.env.API_BASE_URL + `section?current=${params.estado}`;
        axios.get(url)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              throw new Error('Bad data')
            }

            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_BATERIA({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios.get(process.env.API_BASE_URL + `section?field=battery&timestamp=-1&id_section=${params.ducto}&id_rtu=${params.estacion}&start_date=${params.desde}&end_date=${params.hasta}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }

            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    GET_PRESION({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        let lastTimestamp = (params && params.lastTimestamp) || -1
        if (params.ducto === '') {
          return
        }
        axios.get(process.env.API_BASE_URL + `section?field=pressure&timestamp=${lastTimestamp}&id_section=${params.ducto}&id_rtu=${params.estacion}&start_date=${params.desde}&end_date=${params.hasta}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_PRESION({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        let lastTimestamp = (params && params.lastTimestamp) || -1
        if (params.ducto === '') {
          return
        }
        axios.get(process.env.API_BASE_URL + `section?field=pressure&timestamp=${lastTimestamp}&id_section=${params.ducto}&id_rtu=${params.estacion}&start_date=${params.desde}&end_date=${params.hasta}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            if ((JSON.stringify(response.data) !== JSON.stringify(this.state.cached_presion)) && response.data.length !== 0) {
              commit('SET_PRESION', {
                data: response.data
              })
              commit('SET_FILL_STATE', {
                data: true
              })
              return resolve(response)
            } else if (response.data.length === 0) {
              commit('SET_FILL_STATE', {
                data: false
              })
              return resolve('no-data')
            } else {
              commit('SET_FILL_STATE', {
                data: false
              })
              return resolve('same-data')
            }
          })
          .catch(err => {
            commit('SET_PRESION', {
              data: this.state.cached_presion
            })
            console.log('error', err)
            return reject(err)
          })
      })
    },
    QUERY_PRESION({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        let lastTimestamp = (params && params.lastTimestamp) || -1
        if (params.ducto === '') {
          return
        }
        axios.post(`${process.env.API_BASE_URL}section/query`, {
          field: 'pressure',
          timestamp: lastTimestamp,
          id_section: params.ducto,
          id_rtu: params.estacion,
          start_date: params.desde,
          end_date: params.hasta
        })
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            if ((JSON.stringify(response.data) !== JSON.stringify(this.state.cached_presion)) && response.data.length !== 0) {
              commit('SET_PRESION', {
                data: response.data
              })
              commit('SET_FILL_STATE', {
                data: true
              })
              return resolve(response)
            } else if (response.data.length === 0) {
              commit('SET_FILL_STATE', {
                data: false
              })
              return resolve('no-data')
            } else {
              commit('SET_FILL_STATE', {
                data: false
              })
              return resolve('same-data')
            }
          })
          .catch(err => {
            commit('SET_PRESION', {
              data: this.state.cached_presion
            })
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_STATISTICS({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        let lastTimestamp = (params && params.lastTimestamp) || -1
        if (params.ducto === '') {
          return
        }
        axios.get(process.env.API_BASE_URL + `section?field=pressure&timestamp=${lastTimestamp}&id_section=${params.ducto}&start_date=${params.desde}&end_date=${params.hasta}`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            if ((JSON.stringify(response.data) !== JSON.stringify(this.state.cached_presion)) && response.data.length !== 0) {
              commit('SET_PRESION', {
                data: response.data
              })
              commit('SET_FILL_STATE', {
                data: true
              })
              return resolve(response)
            } else if (response.data.length === 0) {
              commit('SET_FILL_STATE', {
                data: false
              })
              return resolve('no-data')
            } else {
              commit('SET_FILL_STATE', {
                data: false
              })
              return resolve('same-data')
            }
          })
          .catch(err => {
            commit('SET_PRESION', {
              data: this.state.cached_presion
            })
            console.log('error', err)
            return reject(err)
          })
      })
    },
    LOAD_PIPELINE_SHAPES({
      commit, getters
    }, params) {
      // const mfile = require('../assets/pipeline_shape/routes.json')
      // const sections = getters.allowedSections
      // commit('SET_ROUTE', R.pick(sections, mfile))

      return new Promise((resolve, reject) => {
        const sections = getters.allowedSections;
        sections.forEach(section => {
          const url = process.env.API_BASE_URL + 'site/getPipeLineShapes?section=' + section;
          const headers = {};
          // headers['If-None-Match'] = getters.GET_ETAG(url)

          axios
            .get(url, { headers })
            .then(resp => {
              if (!resp || resp.status !== 200) {
                // err servidor
                throw new Error('Bad response')
              }
              let response = resp.data
              if (!response || response.code !== 200) {
                // reuse data
                if(response.code === 304) {
                  return resolve();
                }

                throw new Error('Bad data')
              }
              const etag = resp.headers['etag'];
              commit('SET_ETAG', { url, etag });
              const sections = getters.allowedSections;
              commit('SET_ROUTE', R.pick(sections, response.data));
              return resolve(R.pick(sections, response.data))
            })
            .catch(err => {
              console.log('error', err);
              return reject(err)
            })
        })
      })
    },
    LOAD_CHART_DATA({
      commit, getters
    }, params) {
      // const mfile = require('../assets/pipeline_shape/routes.json')
      // commit('SET_CHART_DATA', mfile)
    },
    GET_MONITORING({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios.get(process.env.API_BASE_URL + `monitoring`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            commit('SET_MONITORING', {
              data: response.data
            })
            return resolve()
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    POST_MONITORING_SITE_ENABLED({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios.put(process.env.API_BASE_URL + `monitoring/${params.id_section}/${params.id_site}`, {
          enabled: params.enabled,
          username: params.username
        })
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve()
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    POST_MONITORING_PUBLISH_LEAK({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios.post(process.env.API_BASE_URL + `monitoring/leak/${params.id_leak}`, {
          username: params.username
        })
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve()
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    POST_MONITORING_SETTING({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios.put(process.env.API_BASE_URL + `monitoring/settings`, Object.assign({}, params, {
          username: params.username
        }))
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve()
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    GET_USER_ACCESS_LEVELS ({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios.get(process.env.API_BASE_URL + `user/access_levels`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    GET_USER_SECTIONS ({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios.get(process.env.API_BASE_URL + `user/config_sections`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    GET_USER_DATA ({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios.get(process.env.API_BASE_URL + 'user/' + params.username)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },  
    UNLOCK_USER ({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        axios.put(process.env.API_BASE_URL + `user/${params.username}/unlock`)
          .then(resp => {
            if (!resp || resp.status !== 200) {
              // err servidor
              throw new Error('Bad response')
            }
            let response = resp.data
            if (!response || response.code !== 200) {
              // err data
              throw new Error('Bad data')
            }
            return resolve(response)
          })
          .catch(err => {
            console.log('error', err)
            return reject(err)
          })
      })
    },
    login({
      commit
    }, params) {
      if (!params.username || !params.password) {
        return commit('setModalInfo', {
          ready: true,
          msg: 'Campos Vacios',
          subMsg: 'Favor de llenar los campos faltantes'
        });
      }
      commit('setModalInfo', { ready: false });
      axios.post(process.env.API_BASE_URL + 'user/' + params.username + '/login', { password: params.password })
        .then(response => {
          const code = R.path(['data', 'code'], response);

          if (code !== 200) { // verificaion de usuario y contraseña
            // TODO: Handle error
            return commit('setModalInfo', {
              ready: true,
              msg: code === 999 ? 'El usuario tiene una sesión abierta' : 'Fallo en la verificación',
              subMsg: code === 999 ? 'Cierre su sesión anterior o espere 10 minutos' : 'Usuario o contraseña incorrecta',
              resp: R.prop('data', response)
            });
          }

          document.querySelector('#dismiss-button').click();
          const user = R.compose(
            u => R.assoc('config', R.tryCatch(u => JSON.parse(u.config), R.always({}))(u), u),
            R.pathOr({}, ['data', 'data'])
          )(response)

          commit('SET_DUPLICATE_SESSION', false);
          
          const recoveryGuid = R.path(['data', 'data', 'recoveryGuid'], response);

          if (recoveryGuid) {
            commit('CLEAR_USER');
            commit('SET_RECOVERY_DATA', user);
            router.replace('/passwordrecovery');
          } else {
            commit('SET_USER', user);
            commit('CLEAR_RECOVERY_DATA');
            router.replace('/dashboard');
          }
        })
        .catch(err => {
          commit('CLEAR_RECOVERY_DATA');
          console.log('error', err);
          commit('setModalInfo', {
            ready: true,
            msg: 'Fallo en la verificación',
            subMsg: 'Usuario o contraseña incorrecta',
            resp: err
          });
        })
    },
    logout({
      commit
    }) {
      const _logout = () => {
        var id = setTimeout(function () { }, 0);
        while (id--) {
          window.clearTimeout(id); // will do nothing if no timeout with id is present
        }

        let dismissBtn = document.querySelector('#dismiss-button');
        if (dismissBtn) {
          dismissBtn.click();
        }

        commit('CLEAR_USER');
        router.replace('/');
      }

      if (!this.state.user) {
        return _logout();
      }
      commit('setModalInfo', { ready: false });
      axios.post(`${process.env.API_BASE_URL}user/${R.path(['state', 'user', 'username'], this)}/logout`)
        .then(response => {
          if (R.path(['data', 'code'], response) !== 200) {
            return commit('setModalInfo', {
              ready: true,
              msg: 'Error',
              subMsg: 'Se produjo un error al cerrar sesión'
            });
          }
        }).catch(R.identity)
        .then(_logout);
    },
    requestCode({ commit }, params) {
      return new Promise((resolve, reject) => {
        if (!params.email) {
          commit('setModalInfo', {
            ready: true,
            msg: 'Campo Vacio',
            subMsg: 'Favor de ingresar el correo electrónico'
          });
          return reject(new Error('Email is required'));
        }
        commit('setModalInfo', { ready: false });
        const encodedEmail = Buffer.from(params.email).toString('base64');
        axios.post(process.env.API_BASE_URL + 'user/' + params.guid + '/request-code', {
          email: encodedEmail,
          guid: params.guid
        })
          .then(response => {
            const isSuccess = R.path(['data', 'desc'], response) === 'Success';
            commit('setModalInfo', {
              ready: true,
              msg: 'Código Enviado',
              subMsg: isSuccess ? 'El código de verificación ha sido enviado a su correo electrónico' : 'No se pudo enviar el código de verificación'
            });
            resolve(isSuccess);
          })
          .catch(err => {
            console.log('error', err);
            commit('setModalInfo', {
              ready: true,
              msg: 'Error',
              subMsg: 'Hubo un error al enviar el código de verificación',
              resp: err
            });
            reject(err);
          });
      });
    },
    verifyCode({ commit }, params) {
      return new Promise((resolve, reject) => {
        if (!params.code) {
          commit('setModalInfo', {
            ready: true,
            msg: 'Campo Vacio',
            subMsg: 'Favor de ingresar el código'
          });
          return reject(new Error('Code is required'));
        }
        commit('setModalInfo', { ready: false });
        axios.post(process.env.API_BASE_URL + 'user/' + params.guid + '/verify', {
          guid: params.guid,
          code: params.code
        })
          .then(response => {
            const isValid = R.path(['data', 'data'], response);
            commit('setModalInfo', {
              ready: true,
              msg: 'Código Verificado',
              subMsg: isValid ? 'El código de verificación es correcto' : 'El código de verificación es incorrecto'
            });
            resolve(isValid);
          })
          .catch(err => {
            console.log('error', err);
            commit('setModalInfo', {
              ready: true,
              msg: 'Error',
              subMsg: 'Hubo un error al verificar el código',
              resp: err
            });
            reject(err);
          });
      });
    },
    resetPassword({ commit }, params) {
      return new Promise((resolve, reject) => {
        if (!params.password || !params.confirmPassword) {
          commit('setModalInfo', {
            ready: true,
            msg: 'Campos Vacios',
            subMsg: 'Favor de llenar los campos faltantes'
          });
          return reject(new Error('Password and confirm password are required'));
        }
        if (params.password.length < 5) {
          commit('setModalInfo', {
            ready: true,
            msg: 'Contraseña Corta',
            subMsg: 'La contraseña debe tener al menos 5 caracteres'
          });
          return reject(new Error('Password is too short'));
        }
        if (params.password !== params.confirmPassword) {
          commit('setModalInfo', {
            ready: true,
            msg: 'Contraseñas no coinciden',
            subMsg: 'Favor de verificar que las contraseñas coincidan'
          });
          return reject(new Error('Passwords do not match'));
        }
        commit('setModalInfo', { ready: false });

        // Encode the password to Base64 using Buffer
        const encodedPassword = Buffer.from(params.password).toString('base64');

        axios.post(process.env.API_BASE_URL + 'user/' + params.guid + '/reset', {
          guid: params.guid,
          password: encodedPassword,
          code: params.code
        })
          .then(response => {
            commit('setModalInfo', {
              ready: true,
              msg: 'Contraseña Cambiada',
              subMsg: 'Se ha cambiado la contraseña con éxito'
            });
            resolve(response);
          })
          .catch(err => {
            commit('setModalInfo', {
              ready: true,
              msg: 'Error',
              subMsg: 'Hubo un error al cambiar la contraseña',
              resp: err
            });
            reject(err);
          });
      });
    },
    clearUser({ commit }) {
      commit('CLEAR_USER');
    }
  },
  mutations: {
    SET_DUPLICATE_SESSION(state, flag) {
      state.duplicateSession = flag;
    },
    SET_FILL_STATE(state, {
      data
    }) {
      state.fill = data
    },
    UPDATE_LEAK_STATE(state, {
      data
    }) {
      state.transformed_cached_ductos[data.section]._sites[data.id].leak = data.val
    },
    SET_DUCTOS(state, {
      data
    }) {
      state.cached_ductos = data
      let ductsInfo = {}
      let d = state.cached_ductos
      Object.keys(d).map((key, index) => {
        let section = Section.fromData(d[index])
        Object.keys(d[index].site).forEach(key => {
          section.addSiteFromData(d[index].site[key])
        })
        ductsInfo[section.id] = section
      })
      state.transformed_cached_ductos = ductsInfo
    },
    SET_FUGAS(state, {
      data
    }) {
      if (!data || data.length <= 0) {
        return
      }
      state.last_leak_timestamp = data[0].detection_timestamp;

      let transformed_data = []
      data.forEach((item, index) => {
        let leak = Leak.fromData(item)
        transformed_data.push(leak)
      })
      state.transformed_cached_leaks = transformed_data
    },
    SET_PRESION(state, {
      data
    }) {
      state.cached_presion = data
    },
    SET_CURRENT_CHART_DATA(state, {
      data
    }) {
      state.chartCurrentData = data
    },
    // The mutations calls are the only place that the store can be updated.
    SET_USER(state, payload) {
      state.user = payload;
      Vue.ls.set('user', state.user);
    },
    CLEAR_USER(state) {
      this.$store = null;
      state.user = null;
      Vue.ls.set('user', null);
      Vue.ls.clear();
    },
    SET_RECOVERY_DATA(state, payload) {
      state.recovery = payload;
    },
    CLEAR_RECOVERY_DATA(state) {
      state.recovery = null;
    },
    UPDATE_ALARM_STATUS(state, payload) {

    },
    SET_ROUTE(state, route) {
      state.routes = { ...state.routes, ...route }
    },
    SET_ETAG(state, data) {
      state.ETags[data.url] = data.etag;
    },
    SET_CONCEPTOS(state, data) {
      state.conceptos = data
    },
    SET_HELP(state, data) {
      state.help = data
    },
    SET_CHART_DATA(state, chart) {
      state.charts = { ...state.charts, ...chart }
    },
    SET_MONITORING(state, data) {
      const monitoring = data && data.data && data.data.monitoring || []
      const rtu = monitoring.map(d => {
        return JSON.parse(d.section_info)
      })
      let settings = {}
      data && data.data && data.data.settings &&
        data.data.settings.forEach(s => {
          settings[s.type] = s.value
        }) || {}
      const leaks = data && data.data && data.data.leaks || []

      state.monitoring = {
        rtu: rtu,
        settings: settings,
        leaks: leaks
      }
    },
    setModalInfo(state, data) {
      state.modalInfo = R.defaultTo({}, data);
    }
  },
  getters: {
    // Getters are a way to grab computed data from the store. For example, if you have a project list, one component might only want to show projects that are completed: 
    authToken: state => () => {
      const user = Vue.ls.get('user');
      return R.prop('accessToken', user);
    },
    userName: state => {
      const user = Vue.ls.get('user');
      return R.prop('username', user);
    },
    allowedSections: state => {
      const user = Vue.ls.get('user');
      return R.pathOr([], ['config', 'sections'], user);
    },
    GET_PRESION_SPECIFIC_DATA: state => param => {
      let arr = []
      state.cached_presion.forEach(p => {
        arr.push(p[param])
      })
      return arr
    },
    GET_HOME_DUCTOS_TABLE(state) {
      if (!state.cached_ductos || !state.transformed_cached_ductos) {
        return
      }
      return state.transformed_cached_ductos
    },
    GET_HOME_LEAKS_TABLE(state) {
      if (!state.transformed_cached_leaks) {
        return
      }
      return state.transformed_cached_leaks
    },
    GET_ALL_BITACORA(state) {
      return state.db && state.db.bitacora.filter(b => {
        return b
      })
    },
    GET_ALL_CAMPOS(state) {
      return state.db && state.db.campos.filter(b => {
        return b
      })
    },
    GET_ALL_CAMPOS2(state) {
      return state.db && state.db.camposTable2.filter(b => {
        return b
      })
    },
    GET_OP: state => param => {
      let arr = []
      let x = false
      state.options.forEach((op, i) => {
        if (!op) return;
        if (param.filteredBy !== 'sites') {
          arr.forEach(a => {
            if (op[param.filteredBy] === a) {
              arr.push(`${op[param.filteredBy]}-${op['id_section']}`)
              x = true
            }
          })
          if (!x) {
            arr.push({
              name: op[param.filteredBy],
              value: op['id_section']
            })
          }
        } else {
          op['sites'].forEach((site, i) => {
            if (op['id_section'] === param.ducto) {
              arr.push({
                name: site['site_name'],
                value: site['id_site']
              })
            }
          })
          let temp = []
          arr.forEach((elem, pos, arr) => {
            let x = 0
            if (temp.length === 0) {
              temp.push(elem)
            } else {
              temp.forEach(e => {
                e.name === elem.name ? x++ : ''
              })
              if (x === 0) {
                temp.push(elem)
              }
            }
          })
          arr = temp
        }
        x = false
      })
      return arr
    },
    GET_KM_RANGE: state => params => {
      let result = {}
      state.options.forEach((op, i) => {
        result[op['id_section']] = {
          min: op['km_init'],
          max: op['km_final'],
        }
      })
      return result
    },
    GET_ETAG: state => url => {
      return state.ETags[url];
    },
    GET_CONCEPTOS: state => {
      return state.conceptos
    },
    GET_HELP: state => {
      return state.help
    },
    GET_ROUTES: state => state.routes,
    GET_MONITORING: state => state.monitoring,
    GET_MONITORING_RTU: state => state.monitoring.rtu,
    GET_MONITORING_SETTINGS: state => state.monitoring.settings,
    GET_MONITORING_LEAKS: state => state.monitoring.leaks
  },
  modules: {
    // The modules object provides a way to split your store in multiple stores, but allow them to all remain part of the store tree. As your application grows this is a good way to organize your codebase.
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js